import {  Tabs } from 'antd';
import { ResourceExplorer, TerminologyExplorer, ResourceReferences, NumericObservation, EncounterTimeline, FHIRPath } from '../componentsIndex';



const Navigation = () => {
    const items =  [
        {
            key: '0',
            label: `Resource Explorer`,
            children: <ResourceExplorer/>,
        },
        {
            key: '1',
            label: `Terminology Explorer`,
            children: <TerminologyExplorer/>,
        },
        {
            key: '2',
            label: `Resource References Graph`,
            children: <ResourceReferences/>,
        },
        {
            key: '3',
            label: `Numeric Observations/Vitals`,
            children: <NumericObservation/>,
        },
        {
            key: '4',
            label: `Encounter Timeline`,
            children: <EncounterTimeline/>,
        },
        {
            key: '5',
            label: `FHIRPath`,
            children: <FHIRPath/>,
        }
    ];

    const onChange = (key) => {
    };

    return (
        <div className="head">
            <Tabs
                defaultActiveKey="0"
                items={items}
                onChange={onChange}
                type="card"
                style={{margin:"20px 0px"}}
            />
        </div>
    );
}

export default Navigation;